// quotation-preview Header.js
import React from "react";
import { View, Text, Image } from "@react-pdf/renderer";
import { styles } from "../styles";

const Header = ({ quotationData }) => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const email = user.username || "";
  const domain = email.split("@")[1]?.split(".")[0] || "";
  const companyName =
    domain === "neonworks" ? "NEON" : domain === "optx" ? "OPTX" : "UNKNOWN";

  const logoUrl =
    companyName === "NEON"
      ? "https://i.imgur.com/sfL5dWo.png"
      : companyName === "OPTX"
      ? "https://i.imgur.com/vHJYGdx.png"
      : "";

  const year = new Date(quotationData.documentDate).getFullYear();
  const documentNo = `${companyName}(${quotationData.type})-${year}-${quotationData.runNumber}`;
  const { clientDetails } = quotationData;

  return (
    <View>
      {/* ส่วนหัวของใบเสนอราคา */}
      <View style={styles.header}>
        <View style={styles.logoContainer}>
          {logoUrl && <Image src={logoUrl} style={styles.logo} />}
        </View>
        <View style={styles.headerContent}>
          <Text style={styles.headerTitle}>ใบเสนอราคา</Text>
          <Text style={styles.headerTitleBold}>QUOTATION</Text>
        </View>
      </View>

      {/* รายละเอียดลูกค้าและใบเสนอราคา */}
      <View style={styles.headerDetailsWrapper}>
        <View style={styles.clientDetailsContainer}>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Customer Name:</Text>
            <Text style={styles.value}>
              {clientDetails?.customerName || "N/A"}
            </Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Address:</Text>
            <Text style={[styles.value, styles.multiline]}>
              {clientDetails?.address || "N/A"}
            </Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Tax ID:</Text>
            <Text style={styles.value}>
              {clientDetails?.taxIdentificationNumber || "N/A"}
            </Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Contact:</Text>
            <Text style={styles.value}>
              {clientDetails?.contactPhoneNumber || "N/A"}
            </Text>
          </View>
        </View>

        <View style={styles.headerDetailsContainer}>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Document No.:</Text>
            <Text style={styles.value}>{documentNo}</Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Document Date:</Text>
            <Text style={styles.value}>
              {new Date(quotationData.documentDate).toLocaleDateString("th-TH")}
            </Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Salesperson:</Text>
            <Text style={styles.value}>{quotationData.salePerson || "-"}</Text>
          </View>

          <View style={styles.detailRow}>
            <Text style={styles.label}>Project Name:</Text>
            <Text style={styles.value}>
              {quotationData.projectName || "-"}
            </Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.label}>Project Run:</Text>
            <Text style={styles.value}>
              {quotationData.period || "-"}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default Header;
